import { render, staticRenderFns } from "./DanhGiaKDLDetailForm.vue?vue&type=template&id=69b8ffc6&"
import script from "./DanhGiaKDLDetailForm.vue?vue&type=script&lang=js&"
export * from "./DanhGiaKDLDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports